import React, { FC, useCallback } from "react";
import { IconButton, IconTypesKeys } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useConfirmDialog } from "../../../../../hooks/useDialogs";
import { useUngroupFeature } from "../../../hooks/useUngroupFeature";
import { FeatureDcExtended } from "../../../../../ducks/selectFeatures/types";

type UngroupFeatureButtonProps = {
  kind?: IconTypesKeys;
  feature: FeatureDcExtended;
};

export const UngroupFeatureButton: FC<UngroupFeatureButtonProps> = ({ kind, feature }) => {
  const { t } = useTranslation();
  const showConfirmUngroup = useConfirmDialog();
  const [ungroupFeature] = useUngroupFeature(feature);

  const handleClickUngroupButton = useCallback(() => {
    showConfirmUngroup([""], {
      content: t("ungroupConfirm", { ns: "featureCard" }),
      onConfirm: ungroupFeature,
      okText: t("ungroup", { ns: "featureCard" }),
      cancelText: t("actions.cancel", { ns: "common" }),
      options: {
        maxWidth: "40rem",
      },
    });
  }, [showConfirmUngroup, feature]);

  return <IconButton kind={kind} title={t("ungroup", { ns: "featureCard" })} onClick={handleClickUngroupButton} />;
};
